// extracted by mini-css-extract-plugin
export default {"cls1":"XBy_x6gWcD1kxak7K3RS","cls2":"AhvnvQty1tnBReHWJGBb XBy_x6gWcD1kxak7K3RS"};